/* eslint-disable */
import React, { useEffect, useState, useContext, useRef, useMemo, useCallback } from 'react'
import HeaderSearch from './HeaderSearch'
import './Header.css'
import axios from 'axios'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import {
    Button,
    Popover,
    ListItem,
    Divider,
    SwipeableDrawer,
    Popper,
    Paper,
    Badge,
} from '@material-ui/core'
import { handleRedirectInternal } from '../../../Product/common/components'
import AuthContext from '../../../Product/context/auth/authContext'
import pluginContext from '../../../Product/context/plugin/pluginContext'
import { useMediaQuery } from 'react-responsive'
import { Logo } from '../../../utils/index'
import CartIcon from '../../../utils/CommonFunctionality/Cart/CartIcon'
import Dialog from '@material-ui/core/Dialog'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import Popup from '../../../Product/components/organisms/Popup'
import Headernavmenu from '../../../utils/CommonFunctionality/HeaderNavigaton/headernavigation'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import 'swiper/swiper-bundle.css'
import { EffectCoverflow, Navigation, Autoplay, Pagination } from 'swiper'
import DualCart from '../../../utils/CommonFunctionality/DualCart/DualCart'
import { socketAuction } from '../../../Product/common/socket'
import productContext from '../../../Product/context/product/productContext'
import buyerContext from '../../../Product/context/buyer/buyerContext'
import CartContext from '../../../Product/context/cart/cartContext'
import { userCountHandler } from '../../../Product/common/socketHandler'
import { socket } from '../../../Product/common/socket'
import { AccountCircleOutlined, FavoriteOutlined } from '@material-ui/icons'
import { ThemeConstant } from '../../../utils/ThemeConstants'
const Header = (props) => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const history = useHistory()
    const [anchormenu, setanchormenu] = useState(null)
    const { isAuthenticated, logout, user, userCount, loadUser, dispatchCount } =
        useContext(AuthContext)
    const ProductContext = useContext(productContext)
    const BuyerContext = useContext(buyerContext)
    const cartContext = useContext(CartContext)
    const { cart_items, buyer_cartitems } = cartContext
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const [buynowitems, setBuynowitems] = useState([])
    const [countDetails, setCountDetails] = useState({})
    const {
        search_allproducts,
        get_all_cat,
        getAllSearchProducts,
        productLocalState,
        getallcatanditems,
        setState: setProductState,
        responseStatus,
    } = ProductContext
    const { buyer_allproducts, getAllBuyerProducts } = BuyerContext
    const {
        request_become_seller,
        responseStatus: pluginstatus,
        clearResponse: clearpluginresponse,
    } = useContext(pluginContext)
    const [openModal, setModal] = useState(false)
    const [cartItems, setCartItems] = useState([])
    const [search, setSearch] = useState({
        status: 'watchlist',
        sh_limit: 10,
        page: 1,
        order: 1,
    })
    const [search2, setSearch2] = useState({
        status: 'bidwon',
        sh_limit: 10,
        page: 1,
        order: 1,
        paid: 'unpaid',
    })
    const [watchlistCount, setWatchlistCount] = useState(0)
    const [bidsWonCount, setbidsWonCount] = useState(0)
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const isDesktop = useMediaQuery({
        query: '(min-width: 991px)',
    })
    const isSmall = useMediaQuery({
        query: '(max-width: 991px)',
    })
    const [state, setState] = useState({
        top: false,
        right: false,
    })
    const [locationDialog, setLocationDialog] = useState(false)

    const changeDialogStatus = useCallback(() => {
        setModal(!openModal)
    }, [openModal])
    const [catAnchormenu, setCatAnchormenu] = useState(null)
    const [dealAnchormenu, setDealAnchormenu] = useState(null)
    const handleCatClose = useCallback(() => {
        setTimeout(() => {
            setCatAnchormenu(null)
        }, 0)
    }, [])
    const [filterCatValues, setFilterCatValues] = useState([])

    const [headerMenuOpen, setHeaderMenuOpen] = React.useState(false)
    const [showUnpaid, setShowUnpaid] = useState(true)
    const [mobileSearch, setMobileSearch] = useState(false)
    const anchorRef = React.useRef(null)
    const [anchorE2, setAnchorE2] = useState(null)
    const [anchorE3, setAnchorE3] = useState(null)
    const [open, setOpen] = useState(false)
    const [open3, setOpen3] = useState(false)
    const hoverCatTimeout = React.useRef(null)
    const hoverTimeout = React.useRef(null)

    const handleSearchClick = useCallback(() => {
        setMobileSearch(!mobileSearch)
        setOpen3(false)
        setOpen(false)
    }, [mobileSearch])

    const handleToggle = useCallback(() => {
        setHeaderMenuOpen((prevOpen) => !prevOpen)
    }, [])

    const handleMenuClose = useCallback((event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }
        setHeaderMenuOpen(false)
    }, [])

    const countRef = useRef(countDetails)
    const userRef = useRef(user)

    useEffect(() => {
        const isHidden = localStorage.getItem('topNotifyHidden')
        if (JSON.parse(isHidden) === 'true') {
            setShowUnpaid(false)
        }

        if (userCount) {
            setCountDetails(userCount)
        }

        if (global?.searchCategories) {
            setFilterCatValues(global.searchCategories.sort((a, b) => a.name.localeCompare(b.name)))
        }

        if (!isVarifiedGfTheme) {
            getAllSearchProducts(
                {
                    sh_limit: 12,
                    from: 'buynow',
                    page: 1,
                    orderby: '2',
                    auction_io: 1,
                    auction_city:
                        productLocalState.globalLocation == 'All'
                            ? []
                            : [productLocalState.globalLocation],
                },
                'galleryPage_prt',
            )
        }

        if (search_allproducts.from == 'galleryPage_prt') {
            setBuynowitems(
                search_allproducts?.results?.length > 0 ? search_allproducts.results : [],
            )
        }

        if (window.location.hostname === 'localhost') {
            axios.defaults.headers.common['domain'] = 'auction_preview.ecommerce.auction'
        }

        setCartItems(cart_items)

        if (buyer_allproducts?.from == 'watchlist') {
            setWatchlistCount(buyer_allproducts?.total_only)
        } else if (buyer_allproducts?.from == 'bidwon') {
            setbidsWonCount(buyer_allproducts?.total_only)
        }

        if (pluginstatus) {
            if (pluginstatus.from === 'request_become_seller_from') {
                if (pluginstatus.status === 'success') {
                    if (user?.isemp != 2) {
                        loadUser()
                    }
                    window.open(pluginstatus.message)
                }
            }
            clearpluginresponse()
        }

        if (window.location.href.includes('/reverse-auction')) {
            if (!global.pluginConfiguration?.reverse_auction?.enable) {
                window.location.href = window.location.href.includes(global.storeDetails.id)
                    ? `/${global.storeDetails.id}/search`
                    : `/search`
            }
        }
    }, [
        userCount,
        global?.searchCategories,
        productLocalState.globalLocation,
        search_allproducts,
        cart_items,
        buyer_allproducts,
        pluginstatus,
        isVarifiedGfTheme,
        getAllSearchProducts,
        loadUser,
        clearpluginresponse,
        user?.isemp,
    ])

    useEffect(() => {
        const unpaid = localStorage.getItem('unpaidcount')
        const isHidden = localStorage.getItem('topNotifyHidden')
        if (
            JSON.parse(isHidden) === 'true' &&
            String(countDetails.itemunPaidCount) === JSON.parse(unpaid)
        ) {
            setShowUnpaid(false)
        } else {
            setShowUnpaid(true)
        }
    }, [countDetails])

    useEffect(() => {
        countRef.current = countDetails
        userRef.current = user
    }, [countDetails, user])

    const handler = useCallback(
        (data) => {
            userCountHandler(
                data,
                userRef.current,
                countRef.current,
                setCountDetails,
                dispatchCount,
            )
        },
        [dispatchCount],
    )

    useEffect(() => {
        socket.on('watchlist', handler)

        return () => {
            socket.off('watchlist', handler)
        }
    }, [handler])

    useEffect(() => {
        socketAuction.on('pluginMode', (data) => {
            if (global.storeDetails.site_id === data.site_id) {
                if (data.type === 'reverse_auction') {
                    if (parseInt(data.enable) == 0) {
                        setAlert('Reverse Auction Disabled By Seller', 'warning')
                    }
                    setTimeout(() => {
                        window.location.reload()
                    }, 1500)
                }
            }
        })
    }, [])

    const handleCatMouseEnter = useCallback((event) => {
        clearTimeout(hoverCatTimeout.current)
        setAnchorE3(event.currentTarget)
        setOpen3(true)
    }, [])

    const handleMouseEnter = useCallback((event) => {
        clearTimeout(hoverTimeout.current)
        setAnchorE2(event.currentTarget)
        setOpen(true)
    }, [])

    const handleCatMouseLeave = useCallback(() => {
        hoverCatTimeout.current = setTimeout(() => {
            setOpen3(false)
            setAnchorE3(null)
        }, 100)
    }, [])

    const handleCatMobileClick = useCallback((event) => {
        setAnchorE3(event.currentTarget)
        setOpen3((prev) => !prev)
        setOpen(false)
    }, [])

    const handleMobileClick = useCallback((event) => {
        setAnchorE2(event.currentTarget)
        setOpen((prev) => !prev)
        setOpen3(false)
    }, [])

    const handleMouseLeave = useCallback(() => {
        hoverTimeout.current = setTimeout(() => {
            setOpen(false)
            setAnchorE2(null)
        }, 100)
    }, [])

    const handleCatMenu = useCallback((event) => {
        setCatAnchormenu(event.currentTarget)
    }, [])

    const handleCatMenuClose = useCallback(() => {
        setCatAnchormenu(null)
    }, [])

    const handleDealsClose = useCallback(() => {
        setDealAnchormenu(null)
    }, [])

    const handleDealsMenu = useCallback((event) => {
        setDealAnchormenu(event.currentTarget)
    }, [])

    const handleLocationDialog = useCallback(() => {
        setLocationDialog(false)
    }, [])

    const openLocationDialog = useCallback(() => {
        setLocationDialog(true)
        setOpen3(false)
        setOpen(false)
    }, [])

    const handleLocationChange = useCallback(
        (locationValue) => {
            localStorage.setItem('globalLocation', locationValue)
            setProductState({
                ...productLocalState,
                globalLocation: locationValue,
            })
            setLocationDialog(false)
            if (productLocalState.disableBuynowLocations?.includes(locationValue)) {
                if (
                    window.location.pathname.includes('cart') ||
                    window.location.pathname.includes('/checkout/buynow')
                ) {
                    history.replace('/')
                }
            }
            if (window.location.pathname.includes('product-buyer-auction')) {
                history.replace('/')
            }
        },
        [productLocalState, setProductState, history],
    )

    function handleClickClosedAuctions() {
        const payload = { scrollTo: 'auctions', tab: 'closed' }

        if (location.pathname === '/') {
            window.dispatchEvent(new CustomEvent('navigateToSection', { detail: payload }))

            history.replace(location.pathname, payload)
        } else {
            history.push('/', payload)
        }
    }

    const handleMenu = useCallback((event) => {
        setanchormenu(event.currentTarget)
    }, [])

    const handleClose = useCallback((history, path) => {
        setanchormenu(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }, [])

    const logoutUser = useCallback(() => {
        logout()
        history.push('/login')
    }, [logout, history])

    const toggleDrawer = useCallback(
        (anchor, open) => (event) => {
            setState({ ...state, [anchor]: open })
        },
        [state],
    )

    const confirm_become_seller = useCallback(() => {
        request_become_seller({
            user_id: user.id,
            seller_user_id: global?.storeDetails?.user_id,
            email: user.email,
            firstime: user.isemp != 2 ? 1 : 0,
            store_site_id: global?.storeDetails?.site_id,
        })
    }, [user?.id, user?.email, user?.isemp, request_become_seller])

    const handleClearTopNotify = useCallback(() => {
        localStorage.setItem('topNotifyHidden', JSON.stringify('true'))
        localStorage.setItem('unpaidcount', countDetails.itemunPaidCount)
        setShowUnpaid(false)
    }, [countDetails.itemunPaidCount])

    if (localStorage.getItem('pos')) {
        localStorage.removeItem('pos')
    }

    const imageSrc = isAuthenticated
        ? '/lots-images/greenField/user.png'
        : '/lots-images/greenField/userBlck.png'

    const getStaticPageData = global?.staticDetails || []

    return (
        <>
            {isDesktop ? (
                /* DESKTOP NAVIGATION */
                <>
                    {isVarifiedGfTheme ? (
                        <header className="mainHeader noPrint">
                            <div className="customContainer d-flex justify-content-between align-items-center h-100">
                                <div className="headLt d-flex justify-content-start align-items-center">
                                    <Logo className="headerLogo" />
                                </div>
                                <div className="headerRghtGroup">
                                    <div className="headRt d-flex justify-content-start align-items-center nowrap">
                                        <ul
                                            id={
                                                global.storeDetails.header_theme == '#000000'
                                                    ? 'change-bg-font-color ui'
                                                    : ''
                                            }
                                            className="d-flex justify-content-start align-items-center"
                                        >
                                            {isAuthenticated ? (
                                                <>
                                                    <li className="position-relative">
                                                        <Button
                                                            role="heading"
                                                            aria-level="2"
                                                            aria-label="deals Drop"
                                                            aria-controls="deals Drop"
                                                            aria-haspopup="true"
                                                            className="categoriesButton"
                                                            onMouseEnter={handleCatMouseEnter}
                                                            onMouseLeave={handleCatMouseLeave}
                                                        >
                                                            Categories
                                                        </Button>

                                                        <Popper
                                                            open={open3}
                                                            anchorEl={anchorE3}
                                                            placement="bottom-start"
                                                            className="headerPoperElement"
                                                            disablePortal={true}
                                                            keepMounted={true}
                                                            modifiers={{
                                                                flip: {
                                                                    enabled: false,
                                                                },
                                                                preventOverflow: {
                                                                    enabled: true,
                                                                    boundariesElement:
                                                                        'scrollParent',
                                                                },
                                                            }}
                                                        >
                                                            <Paper
                                                                onMouseEnter={() => {
                                                                    clearTimeout(
                                                                        hoverCatTimeout.current,
                                                                    )
                                                                }}
                                                                onMouseLeave={handleCatMouseLeave}
                                                                sx={{
                                                                    padding: 2,
                                                                    backgroundColor: 'white',
                                                                }}
                                                            >
                                                                <ul className="categoriesDropMenu">
                                                                    {filterCatValues?.map(
                                                                        (data, index) => (
                                                                            <ListItem
                                                                                button
                                                                                key={index}
                                                                                onClick={() => {
                                                                                    handleCatClose()
                                                                                    handleRedirectInternal(
                                                                                        history,
                                                                                        'search/' +
                                                                                            data.description
                                                                                                .replace(
                                                                                                    /[^a-zA-Z0-9]/g,
                                                                                                    ' ',
                                                                                                )
                                                                                                .replace(
                                                                                                    /\s\s+/g,
                                                                                                    ' ',
                                                                                                )
                                                                                                .replace(
                                                                                                    / /g,
                                                                                                    '-',
                                                                                                )
                                                                                                .toLowerCase(),
                                                                                    )
                                                                                }}
                                                                            >
                                                                                <div className="PmCategoryList-root">
                                                                                    <h4 className="PmCategoryTitle m-0">
                                                                                        {data.name}{' '}
                                                                                        {global
                                                                                            .storeConfigration
                                                                                            ?.cat_with_count
                                                                                            ?.value ==
                                                                                        1
                                                                                            ? data.product_cnt
                                                                                            : ''}
                                                                                    </h4>
                                                                                </div>
                                                                            </ListItem>
                                                                        ),
                                                                    )}
                                                                </ul>
                                                            </Paper>
                                                        </Popper>
                                                    </li>
                                                    {isBuyBestProject && (
                                                        <li className="">
                                                            <Button
                                                                className="categoriesButton"
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'how_it_works',
                                                                    )
                                                                }
                                                            >
                                                                How it Works
                                                            </Button>
                                                        </li>
                                                    )}
                                                    {!isBargainsProject && !isBuyBestProject ? (
                                                        <li>
                                                            <Button
                                                                aria-controls="dealsDrop"
                                                                aria-haspopup="true"
                                                                className="categoriesButton"
                                                                onMouseEnter={handleMouseEnter}
                                                                onMouseLeave={handleMouseLeave}
                                                            >
                                                                Deals
                                                            </Button>

                                                            <Popper
                                                                open={open}
                                                                anchorEl={anchorE2}
                                                                placement="bottom-start"
                                                                className="headerPoperElement"
                                                            >
                                                                <Paper
                                                                    onMouseEnter={() => {
                                                                        clearTimeout(
                                                                            hoverTimeout.current,
                                                                        )
                                                                    }}
                                                                    onMouseLeave={handleMouseLeave}
                                                                    sx={{
                                                                        padding: 2,
                                                                        backgroundColor: 'white',
                                                                    }}
                                                                >
                                                                    <ul className="dealsDropMenu">
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'todays-top-deals',
                                                                                )
                                                                            }
                                                                        >
                                                                            Todays Top Deals
                                                                        </ListItem>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'recently-listed',
                                                                                )
                                                                            }
                                                                        >
                                                                            Recently Listed
                                                                        </ListItem>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'deals-ending-soon',
                                                                                )
                                                                            }
                                                                        >
                                                                            Deals Ending Soon
                                                                        </ListItem>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'buynow',
                                                                                )
                                                                            }
                                                                        >
                                                                            Buy Now
                                                                        </ListItem>
                                                                    </ul>
                                                                </Paper>
                                                            </Popper>
                                                        </li>
                                                    ) : isBuyBestProject ? (
                                                        <li>
                                                            <Button
                                                                className="categoriesButton"
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'buynow',
                                                                    )
                                                                }
                                                            >
                                                                Buy Now
                                                            </Button>
                                                        </li>
                                                    ) : null}

                                                    {isBuyBestProject ? (
                                                        <>
                                                            <li>
                                                                <Button
                                                                    className=""
                                                                    onClick={
                                                                        handleClickClosedAuctions
                                                                    }
                                                                >
                                                                    Closed Auctions
                                                                </Button>
                                                            </li>

                                                            {global.pluginConfiguration
                                                                ?.remote_seller?.enable &&
                                                            isAuthenticated ? (
                                                                <li>
                                                                    <Button
                                                                        className=""
                                                                        onClick={
                                                                            confirm_become_seller
                                                                        }
                                                                    >
                                                                        Become Seller
                                                                    </Button>
                                                                </li>
                                                            ) : null}
                                                        </>
                                                    ) : (
                                                        <li>
                                                            <div className="lctnFltr primeLoc">
                                                                <span className="material-icons-outlined lctnIconVw">
                                                                    place
                                                                </span>
                                                                <div
                                                                    className="fltrValue"
                                                                    onClick={openLocationDialog}
                                                                >
                                                                    {
                                                                        productLocalState.globalLocation
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <li>
                                                        <Button
                                                            aria-controls="dealsDrop"
                                                            aria-haspopup="true"
                                                            className="categoriesButton qq"
                                                            onMouseEnter={handleCatMouseEnter}
                                                            onMouseLeave={handleCatMouseLeave}
                                                        >
                                                            Categories
                                                        </Button>

                                                        <Popper
                                                            open={open3}
                                                            anchorEl={anchorE3}
                                                            placement="bottom-start"
                                                            className="headerPoperElement"
                                                        >
                                                            <Paper
                                                                onMouseEnter={() => {
                                                                    clearTimeout(
                                                                        hoverCatTimeout.current,
                                                                    )
                                                                }}
                                                                onMouseLeave={handleCatMouseLeave}
                                                                sx={{
                                                                    padding: 2,
                                                                    backgroundColor: 'white',
                                                                }}
                                                            >
                                                                <ul className="categoriesDropMenu">
                                                                    {filterCatValues?.map(
                                                                        (data, index) => (
                                                                            <ListItem
                                                                                button
                                                                                key={index}
                                                                                onClick={() => {
                                                                                    handleCatClose()
                                                                                    handleRedirectInternal(
                                                                                        history,
                                                                                        'search/' +
                                                                                            data.description
                                                                                                .replace(
                                                                                                    /[^a-zA-Z0-9]/g,
                                                                                                    ' ',
                                                                                                )
                                                                                                .replace(
                                                                                                    /\s\s+/g,
                                                                                                    ' ',
                                                                                                )
                                                                                                .replace(
                                                                                                    / /g,
                                                                                                    '-',
                                                                                                )
                                                                                                .toLowerCase(),
                                                                                    )
                                                                                }}
                                                                            >
                                                                                <div className="PmCategoryList-root">
                                                                                    <h4 className="PmCategoryTitle m-0">
                                                                                        {data.name}{' '}
                                                                                        {global
                                                                                            .storeConfigration
                                                                                            ?.cat_with_count
                                                                                            ?.value ==
                                                                                        1
                                                                                            ? data.product_cnt
                                                                                            : ''}
                                                                                    </h4>
                                                                                </div>
                                                                            </ListItem>
                                                                        ),
                                                                    )}
                                                                </ul>
                                                            </Paper>
                                                        </Popper>
                                                    </li>
                                                    {isBuyBestProject && (
                                                        <li className="">
                                                            <Button
                                                                className="categoriesButton"
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'how_it_works',
                                                                    )
                                                                }
                                                            >
                                                                How it Works
                                                            </Button>
                                                        </li>
                                                    )}
                                                    {!isBargainsProject && !isBuyBestProject ? (
                                                        <li>
                                                            <Button
                                                                aria-controls="dealsDrop"
                                                                aria-haspopup="true"
                                                                className="categoriesButton"
                                                                onMouseEnter={handleMouseEnter}
                                                                onMouseLeave={handleMouseLeave}
                                                            >
                                                                Deals
                                                            </Button>

                                                            <Popper
                                                                open={open}
                                                                anchorEl={anchorE2}
                                                                placement="bottom-start"
                                                                className="headerPoperElement"
                                                            >
                                                                <Paper
                                                                    onMouseEnter={() => {
                                                                        clearTimeout(
                                                                            hoverTimeout.current,
                                                                        )
                                                                    }}
                                                                    onMouseLeave={handleMouseLeave}
                                                                    sx={{
                                                                        padding: 2,
                                                                        backgroundColor: 'white',
                                                                    }}
                                                                >
                                                                    <ul className="dealsDropMenu">
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'todays-top-deals',
                                                                                )
                                                                            }
                                                                        >
                                                                            Todays Top Deals
                                                                        </ListItem>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'recently-listed',
                                                                                )
                                                                            }
                                                                        >
                                                                            Recently Listed
                                                                        </ListItem>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'deals-ending-soon',
                                                                                )
                                                                            }
                                                                        >
                                                                            Deals Ending Soon
                                                                        </ListItem>
                                                                        <ListItem
                                                                            button
                                                                            onClick={() =>
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'buynow',
                                                                                )
                                                                            }
                                                                        >
                                                                            Buy Now
                                                                        </ListItem>
                                                                    </ul>
                                                                </Paper>
                                                            </Popper>
                                                        </li>
                                                    ) : isBuyBestProject ? (
                                                        <li>
                                                            <Button
                                                                className="categoriesButton"
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'buynow',
                                                                    )
                                                                }
                                                            >
                                                                Buy Now
                                                            </Button>
                                                        </li>
                                                    ) : null}

                                                    {isBuyBestProject ? (
                                                        <li>
                                                            <Button
                                                                className=""
                                                                onClick={handleClickClosedAuctions}
                                                            >
                                                                Closed Auctions
                                                            </Button>
                                                        </li>
                                                    ) : (
                                                        <li>
                                                            <div className="lctnFltr primeLoc 123">
                                                                <span className="material-icons-outlined lctnIconVw">
                                                                    place
                                                                </span>
                                                                <div
                                                                    className="fltrValue"
                                                                    onClick={openLocationDialog}
                                                                >
                                                                    {
                                                                        productLocalState.globalLocation
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )}
                                                </>
                                            )}
                                            {getStaticPageData
                                                .filter((page) => page.type === 1)
                                                .map((page, k) => (
                                                    <li key={k}>
                                                        <NavLink
                                                            to={page.pathname}
                                                            activeClassName="active"
                                                            className="hdrLinks"
                                                        >
                                                            {page.description_name}
                                                        </NavLink>
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                    <HeaderSearch />
                                    <div className="headRt d-flex justify-content-start align-items-center nowrap ee">
                                        <ul
                                            id={
                                                global.storeDetails.header_theme == '#000000'
                                                    ? 'change-bg-font-color'
                                                    : ''
                                            }
                                            className="d-flex justify-content-start align-items-center"
                                        >
                                            <Headernavmenu type="desk" />

                                            {isAuthenticated ? (
                                                <>
                                                    <li>
                                                        <div className="userIfBox">
                                                            {isBuyBestProject ? (
                                                                <AccountCircleOutlined />
                                                            ) : (
                                                                <img
                                                                    src="/lots-images/greenField/Vector/userIcon.svg"
                                                                    alt="userIcon"
                                                                    width={30}
                                                                    height={30}
                                                                    loading="lazy"
                                                                    onClick={() => {
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'dashboard/profile',
                                                                        )
                                                                    }}
                                                                />
                                                            )}

                                                            <Button
                                                                aria-controls="simple-menu"
                                                                aria-haspopup="true"
                                                                onClick={handleMenu}
                                                            >
                                                                <span>
                                                                    Hello, {user?.first_name}{' '}
                                                                    {user?.last_name}
                                                                </span>
                                                                My Account
                                                            </Button>
                                                        </div>

                                                        <Popover
                                                            id={'simple-menu'}
                                                            open={Boolean(anchormenu)}
                                                            anchorEl={anchormenu}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                                vertical: 'bottom',
                                                                horizontal: 'right',
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            }}
                                                        >
                                                            <ul className="headerDropMenu">
                                                                <ListItem
                                                                    button
                                                                    onClick={() =>
                                                                        handleClose(
                                                                            history,
                                                                            'dashboard/profile',
                                                                        )
                                                                    }
                                                                >
                                                                    Profile
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={logoutUser}
                                                                >
                                                                    Logout
                                                                </ListItem>
                                                            </ul>
                                                        </Popover>
                                                    </li>
                                                    <li>
                                                        <NavLink
                                                            activeClassName="active"
                                                            to="/dashboard/favorites"
                                                        >
                                                            <div className="favraiteBadgeCircle">
                                                                {isBuyBestProject ? (
                                                                    <FavoriteOutlined />
                                                                ) : (
                                                                    <img
                                                                        src="/lots-images/greenField/Vector/fav.svg"
                                                                        alt="fav"
                                                                        loading="lazy"
                                                                    />
                                                                )}

                                                                <span>
                                                                    {countDetails?.watchlistCount ||
                                                                        0}
                                                                </span>
                                                            </div>
                                                        </NavLink>
                                                    </li>
                                                    {!isBargainsProject && !isBuyBestProject ? (
                                                        <li>
                                                            <NavLink
                                                                activeClassName="active"
                                                                to="/dashboard/redeem"
                                                            >
                                                                <div className="awardBadgeCircle">
                                                                    <img
                                                                        src="/lots-images/greenField/Vector/Vector.svg"
                                                                        alt="Vector"
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                            </NavLink>
                                                        </li>
                                                    ) : null}

                                                    {global.storeConfigration?.disable_buynow
                                                        ?.value !== '1' ? (
                                                        <li className="cartIco">
                                                            {global.pluginConfiguration?.dual_cart
                                                                ?.enable == 1 ? (
                                                                <DualCart />
                                                            ) : (
                                                                <>
                                                                    <CartIcon />
                                                                </>
                                                            )}
                                                        </li>
                                                    ) : null}
                                                </>
                                            ) : (
                                                <li>
                                                    <NavLink className="login-btn" to="/login">
                                                        Login
                                                    </NavLink>
                                                    <NavLink className="signup-btn" to="/sign-up">
                                                        Sign Up
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </header>
                    ) : (
                        <header className="mainHeader noPrint">
                            <div className="customContainer d-flex justify-content-between align-items-center h-100">
                                <div className="headLt d-flex justify-content-start align-items-center">
                                    <Logo className="headerLogo" />
                                </div>
                                <HeaderSearch />
                                <div className="headRt d-flex justify-content-start align-items-center nowrap ">
                                    <ul
                                        id={
                                            global.storeDetails.header_theme == '#000000'
                                                ? 'change-bg-font-color'
                                                : ''
                                        }
                                        className="d-flex justify-content-start align-items-center"
                                    >
                                        <Headernavmenu type="desk" />

                                        {isAuthenticated ? (
                                            <>
                                                {global.storeConfigration?.disable_buynow?.value !==
                                                '1' ? (
                                                    <li>
                                                        {global.pluginConfiguration?.dual_cart
                                                            ?.enable == 1 ? (
                                                            <DualCart />
                                                        ) : (
                                                            <CartIcon />
                                                        )}
                                                    </li>
                                                ) : null}
                                                <li>
                                                    <NavLink
                                                        activeClassName="active"
                                                        to="/dashboard/favorites"
                                                    >
                                                        <img
                                                            src="/lots-images/favourite.svg"
                                                            alt=""
                                                            loading="lazy"
                                                        />
                                                    </NavLink>
                                                </li>

                                                <li>
                                                    <Button
                                                        aria-controls="simple-menu"
                                                        aria-haspopup="true"
                                                        onClick={handleMenu}
                                                    >
                                                        My Account
                                                        <span className="material-icons">
                                                            account_circle
                                                        </span>
                                                    </Button>

                                                    <Popover
                                                        id={'simple-menu'}
                                                        open={Boolean(anchormenu)}
                                                        anchorEl={anchormenu}
                                                        onClose={handleClose}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        }}
                                                    >
                                                        <ul className="headerDropMenu">
                                                            <ListItem
                                                                button
                                                                onClick={() =>
                                                                    handleClose(
                                                                        history,
                                                                        'dashboard/transactions?loc=1',
                                                                    )
                                                                }
                                                            >
                                                                Dashboard
                                                            </ListItem>
                                                            <ListItem button onClick={logoutUser}>
                                                                Logout
                                                            </ListItem>
                                                        </ul>
                                                    </Popover>
                                                </li>
                                            </>
                                        ) : (
                                            <li>
                                                <NavLink className="login-btn" to="/login">
                                                    Login
                                                </NavLink>
                                                <NavLink className="signup-btn" to="/sign-up">
                                                    Sign up
                                                </NavLink>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </header>
                    )}
                </>
            ) : (
                <>
                    {isVarifiedGfTheme ? (
                        <>
                            <header className="mainHeader mobHeader noPrint customContainer">
                                <div className="mobileLftMenu">
                                    <Button
                                        className="respNavBtn"
                                        onClick={toggleDrawer('left', true)}
                                    >
                                        <span className="material-icons">menu</span>
                                    </Button>
                                </div>
                                <div className="mobileBrandIcon">
                                    <Logo className="headerLogo mobView" />
                                </div>
                                <div className="headRt">
                                    <ul
                                        id={
                                            global.storeDetails.header_theme == '#000000'
                                                ? 'change-bg-font-color'
                                                : ''
                                        }
                                        className="text-right d-flex align-items-center"
                                    >
                                        <li
                                            ref={anchorRef}
                                            aria-controls={
                                                headerMenuOpen ? 'menu-list-grow' : undefined
                                            }
                                            aria-haspopup="true"
                                            // onClick={handleToggle}
                                            onClick={() =>
                                                isAuthenticated
                                                    ? handleRedirectInternal(
                                                          history,
                                                          'dashboard/profile',
                                                      )
                                                    : handleRedirectInternal(history, 'login')
                                            }
                                        >
                                            {isBuyBestProject ? (
                                                <AccountCircleOutlined />
                                            ) : (
                                                <img
                                                    src={imageSrc}
                                                    alt="user"
                                                    width="24"
                                                    loading="lazy"
                                                />
                                            )}
                                            {/* {isAuthenticated && (
                                                <span>
                                                    Hello, {user?.first_name} {user?.last_name}
                                                </span>
                                            )} */}
                                        </li>
                                    </ul>
                                </div>
                            </header>
                            {isSmall && (
                                <>
                                    {mobileSearch ? (
                                        <div className="mobileSearch">
                                            <HeaderSearch />
                                            <span
                                                className="material-icons"
                                                onClick={() => setMobileSearch(!mobileSearch)}
                                            >
                                                close
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </>
                            )}
                            {isSmall && (
                                <div className="locationBoxContainer">
                                    <ul
                                        className="parenrUlist"
                                        id={
                                            global.storeDetails.header_theme == '#000000'
                                                ? 'change-bg-font-color'
                                                : ''
                                        }
                                    >
                                        <li className="position-relative">
                                            <Button
                                                role="heading"
                                                aria-level="2"
                                                aria-label="deals Drop"
                                                aria-controls="deals Drop"
                                                aria-haspopup="true"
                                                className="categoriesButton uu"
                                                onClick={handleCatMobileClick}
                                            >
                                                Categories
                                            </Button>

                                            <Popper
                                                open={open3}
                                                anchorEl={anchorE3}
                                                placement="bottom-start"
                                                className="headerPoperElement"
                                                disablePortal={true}
                                                keepMounted={true}
                                                modifiers={{
                                                    flip: {
                                                        enabled: false,
                                                    },
                                                    preventOverflow: {
                                                        enabled: true,
                                                        boundariesElement: 'scrollParent',
                                                    },
                                                }}
                                            >
                                                <Paper
                                                    onMouseEnter={() => {
                                                        clearTimeout(hoverCatTimeout.current)
                                                    }}
                                                    onMouseLeave={handleCatMouseLeave}
                                                    sx={{
                                                        padding: 2,
                                                        backgroundColor: 'white',
                                                    }}
                                                >
                                                    <ul className="categoriesDropMenu">
                                                        {filterCatValues?.map((data, index) => (
                                                            <ListItem
                                                                button
                                                                key={index}
                                                                onClick={() => {
                                                                    handleCatClose()
                                                                    setCatAnchormenu(null)
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'search/' +
                                                                            data.description
                                                                                .replace(
                                                                                    /[^a-zA-Z0-9]/g,
                                                                                    ' ',
                                                                                )
                                                                                .replace(
                                                                                    /\s\s+/g,
                                                                                    ' ',
                                                                                )
                                                                                .replace(/ /g, '-')
                                                                                .toLowerCase(),
                                                                    )
                                                                }}
                                                            >
                                                                <div className="PmCategoryList-root">
                                                                    <h4 className="PmCategoryTitle m-0">
                                                                        {data.name}{' '}
                                                                        {global.storeConfigration
                                                                            ?.cat_with_count
                                                                            ?.value == 1
                                                                            ? data.product_cnt
                                                                            : ''}
                                                                    </h4>
                                                                </div>
                                                            </ListItem>
                                                        ))}
                                                    </ul>
                                                </Paper>
                                            </Popper>
                                        </li>
                                        {isBuyBestProject && (
                                            <li className="">
                                                <Button
                                                    className="categoriesButton"
                                                    onClick={() =>
                                                        handleRedirectInternal(
                                                            history,
                                                            'how_it_works',
                                                        )
                                                    }
                                                >
                                                    How it Works
                                                </Button>
                                            </li>
                                        )}
                                        <li>
                                            {isBuyBestProject ? (
                                                <Button
                                                    className="categoriesButton"
                                                    onClick={() =>
                                                        handleRedirectInternal(history, 'buynow')
                                                    }
                                                >
                                                    Buy Now
                                                </Button>
                                            ) : (
                                                <>
                                                    {' '}
                                                    <Button
                                                        aria-controls="dealsDrop"
                                                        aria-haspopup="true"
                                                        className="categoriesButton"
                                                        onClick={handleMobileClick}
                                                    >
                                                        Deals
                                                    </Button>
                                                    <Popper
                                                        open={open}
                                                        anchorEl={anchorE2}
                                                        placement="bottom-start"
                                                        className="headerPoperElement"
                                                    >
                                                        <Paper
                                                            onMouseEnter={() => {
                                                                clearTimeout(hoverTimeout.current)
                                                            }}
                                                            onMouseLeave={handleMouseLeave}
                                                            sx={{
                                                                padding: 2,
                                                                backgroundColor: 'white',
                                                            }}
                                                        >
                                                            <ul className="dealsDropMenu">
                                                                <ListItem
                                                                    button
                                                                    onClick={() => {
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'todays-top-deals',
                                                                        )
                                                                        setOpen(false)
                                                                    }}
                                                                >
                                                                    Todays Top Deals
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={() => {
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'recently-listed',
                                                                        )
                                                                        setOpen(false)
                                                                    }}
                                                                >
                                                                    Recently Listed
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={() => {
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'deals-ending-soon',
                                                                        )
                                                                        setOpen(false)
                                                                    }}
                                                                >
                                                                    Deals Ending Soon
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={() => {
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'buynow',
                                                                        )
                                                                        setOpen(false)
                                                                    }}
                                                                >
                                                                    Buy Now
                                                                </ListItem>
                                                            </ul>
                                                        </Paper>
                                                    </Popper>
                                                </>
                                            )}
                                        </li>

                                        {/* <li>
                                            <div className="lctnFltr primeLoc">
                                                <span className="material-icons-outlined lctnIconVw">
                                                    place
                                                </span>
                                                <div
                                                    className="fltrValue"
                                                    onClick={openLocationDialog}
                                                >
                                                    {productLocalState.globalLocation}
                                                </div>
                                            </div>
                                        </li> */}
                                        <li
                                            className="mobHedrSch"
                                            onClick={() => handleSearchClick()}
                                        >
                                            <span class="material-icons">search</span>
                                        </li>
                                        {isVarifiedGfTheme && isAuthenticated ? (
                                            <li>
                                                <ListItem button className="p-0">
                                                    <NavLink activeClassName="active" to="/cart">
                                                        <Badge
                                                            badgeContent={
                                                                props?.cartCount > 0
                                                                    ? props.cartCount
                                                                    : buyer_cartitems.results.length
                                                            }
                                                            color="primary"
                                                        >
                                                            {props.fillIcon ? (
                                                                <ShoppingCart />
                                                            ) : (
                                                                <ShoppingCartOutlinedIcon htmlColor="#000" />
                                                            )}
                                                        </Badge>
                                                    </NavLink>
                                                </ListItem>
                                            </li>
                                        ) : null}
                                        {/* {isAuthenticated ? (
                                            <>
                                            </>
                                        ) : (
                                            <>
                                                <li>
                                                    <Button
                                                        role="heading"
                                                        aria-level="2"
                                                        aria-label="deals Drop"
                                                        aria-controls="deals Drop"
                                                        aria-haspopup="true"
                                                        className="categoriesButton uu"
                                                        onMouseEnter={
                                                            !isSmall
                                                                ? handleCatMouseEnter
                                                                : undefined
                                                        }
                                                        onMouseLeave={
                                                            !isSmall
                                                                ? handleCatMouseLeave
                                                                : undefined
                                                        }
                                                        onClick={
                                                            isSmall
                                                                ? handleCatMobileClick
                                                                : undefined
                                                        }
                                                    >
                                                        Categories
                                                    </Button>

                                                    <Popper
                                                        open={open3}
                                                        anchorEl={anchorE3}
                                                        placement="bottom-start"
                                                        className="headerPoperElement"
                                                        disablePortal={true}
                                                        keepMounted={true}
                                                        modifiers={{
                                                            flip: {
                                                                enabled: false,
                                                            },
                                                            preventOverflow: {
                                                                enabled: true,
                                                                boundariesElement: 'scrollParent',
                                                            },
                                                        }}
                                                    >
                                                        <Paper
                                                            onMouseEnter={() => {
                                                                clearTimeout(
                                                                    hoverCatTimeout.current,
                                                                )
                                                            }}
                                                            onMouseLeave={handleCatMouseLeave}
                                                            sx={{
                                                                padding: 2,
                                                                backgroundColor: 'white',
                                                            }}
                                                        >
                                                            <ul className="categoriesDropMenu">
                                                                {filterCatValues?.map(
                                                                    (data, index) => (
                                                                        <ListItem
                                                                            button
                                                                            key={index}
                                                                            onClick={() => {
                                                                                handleCatClose()
                                                                                handleRedirectInternal(
                                                                                    history,
                                                                                    'search?q=&est=0&rat=&view=0&sort=17&slimit=50&cat=' +
                                                                                        data.id,
                                                                                )
                                                                            }}
                                                                        >
                                                                            <div className="PmCategoryList-root">
                                                                                <h4 className="PmCategoryTitle m-0">
                                                                                    {data.name}{' '}
                                                                                    {global
                                                                                        .storeConfigration
                                                                                        ?.cat_with_count
                                                                                        ?.value == 1
                                                                                        ? data.product_cnt
                                                                                        : ''}
                                                                                </h4>
                                                                            </div>
                                                                        </ListItem>
                                                                    ),
                                                                )}
                                                            </ul>
                                                        </Paper>
                                                    </Popper>
                                                </li>
                                                <li>
                                                    <Button
                                                        aria-controls="dealsDrop"
                                                        aria-haspopup="true"
                                                        className="categoriesButton"
                                                        onMouseEnter={
                                                            !isSmall ? handleMouseEnter : undefined
                                                        }
                                                        onMouseLeave={
                                                            !isSmall ? handleMouseLeave : undefined
                                                        }
                                                        onClick={
                                                            isSmall ? handleMobileClick : undefined
                                                        }
                                                    >
                                                        Deals
                                                    </Button>

                                                    <Popper
                                                        open={open}
                                                        anchorEl={anchorE2}
                                                        placement="bottom-start"
                                                        className="headerPoperElement"
                                                    >
                                                        <Paper
                                                            onMouseEnter={() => {
                                                                clearTimeout(hoverTimeout.current)
                                                            }}
                                                            onMouseLeave={handleMouseLeave}
                                                            sx={{
                                                                padding: 2,
                                                                backgroundColor: 'white',
                                                            }}
                                                        >
                                                            <ul className="dealsDropMenu">
                                                                <ListItem
                                                                    button
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'todays-top-deals',
                                                                        )
                                                                    }
                                                                >
                                                                    Todays Top Deals
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'recently-listed',
                                                                        )
                                                                    }
                                                                >
                                                                    Recently Listed
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'deals-ending-soon',
                                                                        )
                                                                    }
                                                                >
                                                                    Deals Ending Soon
                                                                </ListItem>
                                                                <ListItem
                                                                    button
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'buynow',
                                                                        )
                                                                    }
                                                                >
                                                                    Buy Now
                                                                </ListItem>
                                                            </ul>
                                                        </Paper>
                                                    </Popper>
                                                </li>
                                                <li>
                                                    <div className="lctnFltr primeLoc">
                                                        <span className="material-icons-outlined lctnIconVw">
                                                            place
                                                        </span>
                                                        <div
                                                            className="fltrValue"
                                                            onClick={openLocationDialog}
                                                        >
                                                            {productLocalState.globalLocation}
                                                        </div>
                                                    </div>
                                                </li>
                                            </>
                                        )} */}
                                    </ul>
                                </div>
                            )}
                        </>
                    ) : (
                        <header className="mainHeader mobHeader noPrint customContainer d-flex justify-content-between align-items-center">
                            <div className="headLt d-flex justify-content-start">
                                <Logo className="headerLogo" />
                            </div>
                            <div className="headRt">
                                <ul
                                    id={
                                        global.storeDetails.header_theme == '#000000'
                                            ? 'change-bg-font-color'
                                            : ''
                                    }
                                    className="d-flex justify-content-start ml-auto align-items-center"
                                >
                                    <li className="headCart">
                                        <Button
                                            className="respNavBtn"
                                            onClick={toggleDrawer('top', true)}
                                        >
                                            <span className="material-icons">search</span>
                                        </Button>
                                    </li>

                                    {global.storeConfigration?.disable_buynow?.value !== '1' ? (
                                        <li>
                                            {global.pluginConfiguration?.dual_cart?.enable == 1 ? (
                                                <DualCart />
                                            ) : (
                                                <CartIcon />
                                            )}
                                        </li>
                                    ) : null}

                                    <li className="headCart">
                                        <Button
                                            className="respNavBtn"
                                            onClick={toggleDrawer('right', true)}
                                        >
                                            <span className="material-icons">menu</span>
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        </header>
                    )}

                    <React.Fragment>
                        <SwipeableDrawer
                            className="respHeaderSearch"
                            anchor={'top'}
                            open={state['top']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('top', false)}
                            onOpen={toggleDrawer('top', true)}
                        >
                            <HeaderSearch onClose={() => setState({ top: false })} />
                        </SwipeableDrawer>
                    </React.Fragment>
                    <React.Fragment>
                        <SwipeableDrawer
                            className="headerDrawer rrMobileDrawer"
                            anchor={'left'}
                            open={state['left']}
                            disableBackdropTransition={!iOS}
                            disableDiscovery={iOS}
                            disableSwipeToOpen={false}
                            onClose={toggleDrawer('left', false)}
                            onOpen={toggleDrawer('left', true)}
                        >
                            <div className="headRt respNav d-flex justify-content-start align-items-center">
                                <div className="naLogoHead d-flex justify-content-between align-items-center">
                                    <Link to="/">
                                        <img
                                            className="headerLogo"
                                            src={global?.storeDetails?.logoValue}
                                            alt={`${global?.storeDetails?.name} logo`}
                                            loading="lazy"
                                        />{' '}
                                    </Link>
                                    <Button
                                        className="headDrawerClose"
                                        onClick={toggleDrawer('left', false)}
                                    >
                                        close
                                        <span className="material-icons">clear</span>
                                    </Button>
                                </div>
                                <Divider />
                                <ul className="navRespLinks" onClick={toggleDrawer('left', false)}>
                                    {!isAuthenticated ? (
                                        <>
                                            <ListItem button>
                                                <NavLink activeClassName="active" to="/login">
                                                    <span className="material-icons">login</span>
                                                    Login
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink activeClassName="active" to="/sign-up">
                                                    <span className="material-icons">
                                                        how_to_reg
                                                    </span>
                                                    Register
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <ListItem button>
                                        <NavLink activeClassName="active" to="/" exact>
                                            <span class="material-icons">home</span> Home
                                        </NavLink>
                                    </ListItem>
                                    {isVarifiedGfTheme ? (
                                        <ListItem button>
                                            <NavLink
                                                activeClassName="active"
                                                to="/search?q=&est=0&rat=&cat=&view=0&sort=17&slimit=50"
                                                exact
                                            >
                                                <span class="material-icons">search</span> Search
                                            </NavLink>
                                        </ListItem>
                                    ) : (
                                        <ListItem button>
                                            <NavLink activeClassName="active" to="/auctions" exact>
                                                <span class="material-icons">search</span> Auctions
                                            </NavLink>
                                        </ListItem>
                                    )}
                                    {global.storeConfigration?.disable_buynow?.value !== '1' &&
                                    buynowitems.length > 0 ? (
                                        <>
                                            {isVarifiedGfTheme ? null : (
                                                <ListItem button>
                                                    <NavLink
                                                        activeClassName="active"
                                                        to="/gallery"
                                                        exact
                                                    >
                                                        <span class="material-icons">
                                                            collections
                                                        </span>
                                                        {global.storeConfigration
                                                            ?.buy_now_change_text?.value !== '1' &&
                                                        global.storeConfigration
                                                            ?.buy_now_change_text?.value
                                                            ? global.storeConfigration
                                                                  .buy_now_change_text.value
                                                            : global.storeConfigration
                                                                  ?.buy_now_change_text?.value !==
                                                              '1'
                                                            ? 'Buy Now'
                                                            : ''}
                                                    </NavLink>
                                                </ListItem>
                                            )}
                                        </>
                                    ) : null}

                                    {global.pluginConfiguration?.reverse_auction?.enable ? (
                                        <ListItem button>
                                            <NavLink
                                                activeClassName="active"
                                                to="/reverse-auction"
                                                exact
                                            >
                                                <span class="material-icons">search</span> Reverse
                                                Auction
                                            </NavLink>
                                        </ListItem>
                                    ) : (
                                        ''
                                    )}
                                    {global.pluginConfiguration?.remote_seller?.enable &&
                                    isAuthenticated ? (
                                        <ListItem button onClick={() => confirm_become_seller}>
                                            <span class="material-icons">search</span> Become Seller
                                        </ListItem>
                                    ) : (
                                        ''
                                    )}

                                    {global.storeConfigration?.external_schedule_pickup_link
                                        ?.value && (
                                        <ListItem button onClick={() => setModal(true)}>
                                            <span class="material-icons">local_shipping</span>{' '}
                                            Schedule Pickup
                                        </ListItem>
                                    )}

                                    {isAuthenticated && (
                                        <>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/mybids"
                                                >
                                                    <span className="material-icons">gavel</span>
                                                    My Bids
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/transactions"
                                                >
                                                    <span className="material-icons">receipt</span>
                                                    {ThemeConstant?.isBuyBestProject
                                                        ? 'Book Your Appointment'
                                                        : 'Purchase History'}
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/mycart"
                                                >
                                                    <span className="material-icons">
                                                        shopping_cart
                                                    </span>
                                                    My Cart
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/favorites"
                                                >
                                                    <span className="material-icons">favorite</span>
                                                    Watchlist
                                                </NavLink>
                                            </ListItem>

                                            {global?.pluginConfiguration?.buyers_assurance
                                                ?.enable == 1 && (
                                                <ListItem button>
                                                    <NavLink
                                                        to="/dashboard/subscription"
                                                        activeClassName="active"
                                                    >
                                                        <span className="material-icons">
                                                            store
                                                        </span>
                                                        Subscription
                                                    </NavLink>
                                                </ListItem>
                                            )}
                                            {isVarifiedGfTheme ? null : (
                                                <ListItem button>
                                                    <NavLink
                                                        activeClassName="active"
                                                        to="/dashboard/preference"
                                                    >
                                                        <span class="material-icons">
                                                            notifications
                                                        </span>
                                                        Preference
                                                    </NavLink>
                                                </ListItem>
                                            )}
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/dashboard/cards"
                                                >
                                                    <span className="material-icons">
                                                        credit_card
                                                    </span>
                                                    Saved Cards
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    )}
                                    {isVarifiedGfTheme ? null : (
                                        <>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/businessLiquidations"
                                                >
                                                    <span className="material-icons">groups</span>
                                                    Business Liquidations
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/estateLiquidations"
                                                >
                                                    <span className="material-icons">groups</span>
                                                    Estate Liquidations
                                                </NavLink>
                                            </ListItem>
                                            <ListItem button>
                                                <NavLink
                                                    activeClassName="active"
                                                    to="/inventoryReduction"
                                                >
                                                    <span className="material-icons">groups</span>
                                                    Inventory Reduction
                                                </NavLink>
                                            </ListItem>

                                            <ListItem button>
                                                <NavLink activeClassName="active" to="/aboutus">
                                                    <span className="material-icons">groups</span>
                                                    About Us
                                                </NavLink>
                                            </ListItem>
                                        </>
                                    )}
                                    {global.storeConfigration?.disable_faq?.value !== '1' ? (
                                        <ListItem button>
                                            <NavLink activeClassName="active" to="/faq">
                                                <span className="material-icons">quiz</span>
                                                FAQs
                                            </NavLink>
                                        </ListItem>
                                    ) : null}

                                    <ListItem button>
                                        <NavLink activeClassName="active" to="/how_it_works">
                                            <span className="material-icons">groups</span>
                                            How It Works
                                        </NavLink>
                                    </ListItem>
                                    <ListItem button>
                                        <NavLink activeClassName="active" to="/conditions">
                                            <span className="material-icons">description</span>
                                            Terms & Conditions
                                        </NavLink>
                                    </ListItem>
                                    <Headernavmenu type="mobile" />

                                    {!isAuthenticated ? (
                                        <></>
                                    ) : (
                                        <ListItem button onClick={logoutUser}>
                                            <span className="material-icons">
                                                power_settings_new
                                            </span>
                                            Logout
                                        </ListItem>
                                    )}
                                </ul>
                            </div>
                        </SwipeableDrawer>
                    </React.Fragment>
                </>
            )}

            {global?.storeDetails?.text?.length > 0 ? (
                <div className="textSliderWrapper py-2">
                    <Swiper
                        navigation={false}
                        spaceBetween={13}
                        grabCursor={true}
                        slidesPerView={1}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={false}
                        modules={[Autoplay, EffectCoverflow, Navigation, Pagination]}
                        className="mySwiper"
                    >
                        {global?.storeDetails?.text?.map((val, index) => (
                            <SwiperSlide key={index}>
                                <div>
                                    <p className="mb-0">{val}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            ) : (
                ''
            )}
            {isAuthenticated && showUnpaid && countDetails.itemunPaidCount > 0 ? (
                <div className="auctionHasItems noPrint">
                    <img src="/assets/svg/TrophyIcon.svg" alt="troplyPng" loading="lazy" />
                    <h3 className="autionStatus">
                        Congratulations! You're the winner.{' '}
                        <Link
                            to={
                                global.pluginConfiguration?.dual_cart?.enable == 1
                                    ? '/auctioncart'
                                    : `/dashboard/transactions`
                            }
                        >
                            Click here
                        </Link>{' '}
                        {!isVarifiedGfTheme
                            ? 'to make the payment.'
                            : 'to see what items you have won!'}
                    </h3>
                    <i className="material-icons clearTopMessage" onClick={handleClearTopNotify}>
                        clear
                    </i>
                </div>
            ) : null}

            <Popup
                open={openModal}
                size="md"
                handleClose={changeDialogStatus}
                modaltitle="Schedule Pickup"
            >
                <div className="schedulePickup">
                    <iframe
                        height={600}
                        src={global.storeConfigration?.external_schedule_pickup_link?.value}
                        loading="lazy"
                    ></iframe>
                </div>
            </Popup>

            <Dialog
                className="slctLctnPopup"
                open={locationDialog}
                keepMounted
                onClose={handleLocationDialog}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <div className="lctnDialogWrapper">
                    {isVarifiedGfTheme ? null : (
                        <div className="imgWrpr">
                            <img src="/assets/images/locIcon.png" loading="lazy" />
                        </div>
                    )}
                    <div className="rtInfoWrpr">
                        {!isVarifiedGfTheme && <h3>Shopping Location</h3>}
                        <label>You are currently shopping in</label>
                        <p className="crntLctn">
                            <span className="material-icons">location_on</span>
                            {productLocalState.globalLocation}
                        </p>
                        {productLocalState.globalLocations?.length > 1 ? (
                            <>
                                <h4>Other Location</h4>
                                {productLocalState.globalLocations.map(
                                    (val) =>
                                        productLocalState.globalLocation !== val && (
                                            <Button
                                                key={val}
                                                className="othLctn"
                                                onClick={() => handleLocationChange(val)}
                                            >
                                                {val}
                                            </Button>
                                        ),
                                )}
                            </>
                        ) : null}
                    </div>
                </div>
            </Dialog>

            <Popover
                id={'simple-menu'}
                open={headerMenuOpen}
                anchorEl={anchorRef.current}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <ul className="headerDropMenu mb-2">
                    {isAuthenticated ? (
                        <>
                            <ListItem
                                button
                                onClick={() => handleRedirectInternal(history, 'dashboard/profile')}
                            >
                                Profile
                            </ListItem>
                            <ListItem button onClick={logoutUser}>
                                Logout
                            </ListItem>
                        </>
                    ) : (
                        <ListItem button>
                            <NavLink to="/login">Login</NavLink>
                        </ListItem>
                    )}
                </ul>
            </Popover>
        </>
    )
}

export default React.memo(Header)
